import { Component } from "react";
import "./Toast.css";
import { Link } from "react-router-dom";

export default class Toast extends Component {
  constructor(props) {
    super(props);

    this.state = {
      visible: this.props.showToast,
    };

    this.timeout = this.props.timeout || 5000;
  }

  componentWillMount() {
    const _this = this;
    setTimeout(() => {
      !_this.unmounted && _this.setState({ visible: false });
    }, this.timeout);
  }

  componentWillUnmount() {
    this.unmounted = true;
  }

  render() {
    if (this.state.visible) {
      return (
        <div className="app-toast" data-cy={this.props.dataCy}>
          <div className="inner">{this.props.message}</div>
          {this.props.callbackUrl && this.props.callbackLabel && (
            <div className="callback">
              <Link className="callbackUrl" to={this.props.callbackUrl}>
                {this.props.callbackLabel}
              </Link>
            </div>
          )}
        </div>
      );
    } else {
      return null;
    }
  }
}
